import Phaser from 'phaser';
import { SCENE_KEYS } from '@/config/constants';
import { useGameStore } from '@/store/gameStore';

export class BootScene extends Phaser.Scene {
  constructor() {
    super(SCENE_KEYS.boot);
  }

  create() {
    useGameStore.getState().setStatus('Boot scene lista');
    this.scene.start(SCENE_KEYS.preload);
  }
}
